import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32;

import { normalizePhoneNumber, WAITLIST_STATUS_TYPES } from "@dp/common";
import BrandRules from "../../utils/BrandRules";
import { computed, observable, runInAction, makeObservable, action } from "mobx";
import { persist } from "mobx-persist";
import * as yup from "yup";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

var _SCHEMA = yup.object({
  firstName: yup.string().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  lastName: yup.string().required("This field is mandatory").nullable(),
  email: yup.string().email("Please enter a valid email").required("This field is mandatory"),
  partySize: yup.number().required("This field is mandatory").moreThan(0).test("len", "Please Enter your Party-size", function (val) {
    return val > 0;
  }),
  phoneNumber: yup.string().matches(phoneRegExp, "Phone number is not valid").required("This field is mandatory")
});

export var JoinWaitlistModel = (_class = /*#__PURE__*/function () {
  function JoinWaitlistModel(platformUtil) {
    _classCallCheck(this, JoinWaitlistModel);

    _initializerDefineProperty(this, "_firstName", _descriptor, this);

    _initializerDefineProperty(this, "_lastName", _descriptor2, this);

    _initializerDefineProperty(this, "_email", _descriptor3, this);

    _initializerDefineProperty(this, "_phoneNumber", _descriptor4, this);

    _initializerDefineProperty(this, "_waitListId", _descriptor5, this);

    _initializerDefineProperty(this, "_visitId", _descriptor6, this);

    _initializerDefineProperty(this, "_partySize", _descriptor7, this);

    _initializerDefineProperty(this, "_eclubOptin", _descriptor8, this);

    _initializerDefineProperty(this, "_waitListPositionValue", _descriptor9, this);

    _initializerDefineProperty(this, "_requestTime", _descriptor10, this);

    _initializerDefineProperty(this, "_highQuote", _descriptor11, this);

    _initializerDefineProperty(this, "_lowQuote", _descriptor12, this);

    _initializerDefineProperty(this, "_defaultPartySize", _descriptor13, this);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor14, this);

    _initializerDefineProperty(this, "_restaurantId", _descriptor15, this);

    _initializerDefineProperty(this, "_currentWaitlistRestNum", _descriptor16, this);

    _initializerDefineProperty(this, "_restaurantWorkHours", _descriptor17, this);

    _initializerDefineProperty(this, "_remoteCheckinEnabled", _descriptor18, this);

    _initializerDefineProperty(this, "_isChangeWaitlistModalOpen", _descriptor19, this);

    _initializerDefineProperty(this, "_isHowItWoksModalOpen", _descriptor20, this);

    _initializerDefineProperty(this, "_estimatedTime", _descriptor21, this);

    _initializerDefineProperty(this, "_isWaitListAvailable", _descriptor22, this);

    _defineProperty(this, "_waitListTimeDetails", []);

    _initializerDefineProperty(this, "_appAttributes", _descriptor23, this);

    _initializerDefineProperty(this, "_pdfMenuUrl", _descriptor24, this);

    _initializerDefineProperty(this, "_joinWaitlistFormContainerRef", _descriptor25, this);

    _initializerDefineProperty(this, "_scrollJoinWaitlistFormElement", _descriptor26, this);

    _initializerDefineProperty(this, "_joinWaitListFormSubmitCount", _descriptor27, this);

    _initializerDefineProperty(this, "_isCTALoading", _descriptor28, this);

    _initializerDefineProperty(this, "_wineWhileYouWaitInfo", _descriptor29, this);

    _initializerDefineProperty(this, "_isEditWLConfirmation", _descriptor30, this);

    _initializerDefineProperty(this, "_isWaitlistNumberOfGuestsChange", _descriptor31, this);

    _initializerDefineProperty(this, "_isWaitlistFormDataChange", _descriptor32, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(JoinWaitlistModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(appAttributes) {
      this._appAttributes = appAttributes;
    }
  }, {
    key: "setWaitlistDetails",
    value: function setWaitlistDetails(_waitlistDetails) {
      if (_waitlistDetails !== null && _waitlistDetails !== void 0 && _waitlistDetails.restaurantDetail) {
        this._restaurantDetail = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : _waitlistDetails.restaurantDetail;
      }

      if (_waitlistDetails !== null && _waitlistDetails !== void 0 && _waitlistDetails.userDetail) {
        var _waitlistDetails$user, _waitlistDetails$user2, _waitlistDetails$user3, _waitlistDetails$user4;

        this._email = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$user = _waitlistDetails.userDetail) === null || _waitlistDetails$user === void 0 ? void 0 : _waitlistDetails$user.email;
        this._firstName = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$user2 = _waitlistDetails.userDetail) === null || _waitlistDetails$user2 === void 0 ? void 0 : _waitlistDetails$user2.firstName;
        this._lastName = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$user3 = _waitlistDetails.userDetail) === null || _waitlistDetails$user3 === void 0 ? void 0 : _waitlistDetails$user3.lastName;
        this._phoneNumber = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$user4 = _waitlistDetails.userDetail) === null || _waitlistDetails$user4 === void 0 ? void 0 : _waitlistDetails$user4.phoneNumber;
      }

      if (_waitlistDetails !== null && _waitlistDetails !== void 0 && _waitlistDetails.waitListDetail) {
        var _waitlistDetails$wait, _waitlistDetails$wait2, _waitlistDetails$wait3, _waitlistDetails$wait4, _waitlistDetails$wait5;

        this._partySize = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$wait = _waitlistDetails.waitListDetail) === null || _waitlistDetails$wait === void 0 ? void 0 : _waitlistDetails$wait.partySize;
        this._waitListPositionValue = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$wait2 = _waitlistDetails.waitListDetail) === null || _waitlistDetails$wait2 === void 0 ? void 0 : _waitlistDetails$wait2.waitListPositionValue;
        this._highQuote = "".concat(_waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$wait3 = _waitlistDetails.waitListDetail) === null || _waitlistDetails$wait3 === void 0 ? void 0 : _waitlistDetails$wait3.highQuote);
        this._lowQuote = "".concat(_waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$wait4 = _waitlistDetails.waitListDetail) === null || _waitlistDetails$wait4 === void 0 ? void 0 : _waitlistDetails$wait4.lowQuote);
        this._defaultPartySize = _waitlistDetails === null || _waitlistDetails === void 0 ? void 0 : (_waitlistDetails$wait5 = _waitlistDetails.waitListDetail) === null || _waitlistDetails$wait5 === void 0 ? void 0 : _waitlistDetails$wait5.partySize;
      }
    }
  }, {
    key: "resetValues",
    value: function resetValues() {
      var _this = this;

      runInAction(function () {
        _this._firstName = "";
        _this._lastName = "";
        _this._email = "";
        _this._phoneNumber = "";
        _this._partySize = null;
        _this._eclubOptin = true;
        _this._restaurantWorkHours = "";
        _this._waitListPositionValue = null;
        _this._pdfMenuUrl = null;
      });
    }
  }, {
    key: "setIsWaitlisNumberOfGuestsChange",
    value: function setIsWaitlisNumberOfGuestsChange(val) {
      this._isWaitlistNumberOfGuestsChange = val;
    }
  }, {
    key: "setIsWaitlisFormDataChange",
    value: function setIsWaitlisFormDataChange(val) {
      this._isWaitlistFormDataChange = val;
    }
  }, {
    key: "setJoinWaitlistFormContainerRef",
    value: function setJoinWaitlistFormContainerRef(_ref) {
      this._joinWaitlistFormContainerRef = _ref;
    }
  }, {
    key: "setScrollJoinWaitlistFormElement",
    value: function setScrollJoinWaitlistFormElement(value) {
      this._scrollJoinWaitlistFormElement = value;
    }
  }, {
    key: "setJoinWaitlistFormSubmitCount",
    value: function setJoinWaitlistFormSubmitCount(val) {
      this._joinWaitListFormSubmitCount = val;
    }
  }, {
    key: "setIsCTALoading",
    value: function setIsCTALoading(isCTALoading) {
      this._isCTALoading = isCTALoading;
    }
  }, {
    key: "pdfMenuUrl",
    get: function get() {
      return this._pdfMenuUrl;
    },
    set: function set(url) {
      var _this2 = this;

      runInAction(function () {
        _this2._pdfMenuUrl = url;
      });
    }
  }, {
    key: "showPDFMenu",
    get: function get() {
      var _this$_appAttributes;

      return new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode).showPDFMenu();
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "requestTime",
    get: function get() {
      return this._requestTime;
    },
    set: function set(_requestTime) {
      var _this3 = this;

      runInAction(function () {
        _this3._requestTime = _requestTime;
      });
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    },
    set: function set(_firstName) {
      var _this4 = this;

      runInAction(function () {
        _this4._firstName = _firstName;
      });
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    },
    set: function set(_lastName) {
      var _this5 = this;

      runInAction(function () {
        _this5._lastName = _lastName;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    },
    set: function set(_email) {
      var _this6 = this;

      runInAction(function () {
        _this6._email = _email;
      });
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._phoneNumber;
    },
    set: function set(value) {
      var _this7 = this;

      var newNumber = normalizePhoneNumber(value, this._phoneNumber);
      runInAction(function () {
        _this7._phoneNumber = newNumber;
      });
    }
  }, {
    key: "partySize",
    get: function get() {
      return this._partySize;
    },
    set: function set(_partySize) {
      var _this8 = this;

      runInAction(function () {
        _this8._partySize = _partySize;
      });
    }
  }, {
    key: "eclubOptin",
    get: function get() {
      return this._eclubOptin;
    },
    set: function set(eclubOptin) {
      var _this9 = this;

      runInAction(function () {
        _this9._eclubOptin = eclubOptin;
      });
    }
  }, {
    key: "currentWaitlistRestNum",
    get: function get() {
      return this._currentWaitlistRestNum;
    },
    set: function set(currentWaitlistRestNum) {
      var _this10 = this;

      runInAction(function () {
        _this10._currentWaitlistRestNum = currentWaitlistRestNum;
      });
    }
  }, {
    key: "waitListId",
    get: function get() {
      return this._waitListId;
    },
    set: function set(_waitListId) {
      var _this11 = this;

      runInAction(function () {
        _this11._waitListId = _waitListId;
      });
    }
  }, {
    key: "visitId",
    get: function get() {
      return this._visitId;
    },
    set: function set(_visitId) {
      var _this12 = this;

      runInAction(function () {
        _this12._visitId = _visitId;
      });
    }
  }, {
    key: "address",
    get: function get() {
      var _this$restaurantDetai, _this$restaurantDetai2;

      return (_this$restaurantDetai = this.restaurantDetail) === null || _this$restaurantDetai === void 0 ? void 0 : (_this$restaurantDetai2 = _this$restaurantDetai.contactDetail) === null || _this$restaurantDetai2 === void 0 ? void 0 : _this$restaurantDetai2.address;
    }
  }, {
    key: "waitListPositionValue",
    get: function get() {
      return this._waitListPositionValue;
    },
    set: function set(_waitListPositionValue) {
      var _this13 = this;

      runInAction(function () {
        _this13._waitListPositionValue = _waitListPositionValue;
      });
    }
  }, {
    key: "lowQuote",
    get: function get() {
      return this._lowQuote;
    },
    set: function set(_lowQuote) {
      var _this14 = this;

      runInAction(function () {
        _this14._lowQuote = _lowQuote;
      });
    }
  }, {
    key: "highQuote",
    get: function get() {
      return this._highQuote;
    },
    set: function set(_highQuote) {
      var _this15 = this;

      runInAction(function () {
        _this15._highQuote = _highQuote;
      });
    }
  }, {
    key: "isWaitListAvailable",
    get: function get() {
      return this._isWaitListAvailable;
    },
    set: function set(_isWaitListAvailable) {
      var _this16 = this;

      runInAction(function () {
        _this16._isWaitListAvailable = _isWaitListAvailable;
      });
    }
  }, {
    key: "restaurantName",
    get: function get() {
      var _this$restaurantDetai3;

      return ((_this$restaurantDetai3 = this.restaurantDetail) === null || _this$restaurantDetai3 === void 0 ? void 0 : _this$restaurantDetai3.restaurantName) || "";
    }
    /*
    @computed
     public get currentWaitlistRestNum(): string {
       return this._currentWaitlistRestNum;
     }
     public set currentWaitlistRestNum(_currentWaitlistRestNum: string) {
       runInAction(() => {
         this._currentWaitlistRestNum = _currentWaitlistRestNum;
       });
     }
    */

  }, {
    key: "remoteCheckinEnabled",
    get: function get() {
      return this._remoteCheckinEnabled;
    },
    set: function set(_val) {
      var _this17 = this;

      runInAction(function () {
        _this17._remoteCheckinEnabled = _val;
      });
    }
  }, {
    key: "isChangeWaitlistModalOpen",
    get: function get() {
      return this._isChangeWaitlistModalOpen;
    },
    set: function set(_isChangeWaitlistModalOpen) {
      var _this18 = this;

      runInAction(function () {
        _this18._isChangeWaitlistModalOpen = _isChangeWaitlistModalOpen;
      });
    }
  }, {
    key: "maxPartySize",
    get: function get() {
      var _this$restaurantDetai4, _this$restaurantDetai5;

      return ((_this$restaurantDetai4 = this.restaurantDetail) === null || _this$restaurantDetai4 === void 0 ? void 0 : (_this$restaurantDetai5 = _this$restaurantDetai4.partySizeInfo) === null || _this$restaurantDetai5 === void 0 ? void 0 : _this$restaurantDetai5.restMaxPartySize) || 1;
    }
  }, {
    key: "defaultPartySize",
    get: function get() {
      return this._defaultPartySize;
    },
    set: function set(_defaultPartySize) {
      var _this19 = this;

      runInAction(function () {
        _this19._defaultPartySize = _defaultPartySize;
      });
    }
  }, {
    key: "phoneInfo",
    get: function get() {
      var _this$restaurantDetai6, _this$restaurantDetai7;

      return normalizePhoneNumber((_this$restaurantDetai6 = this.restaurantDetail) === null || _this$restaurantDetai6 === void 0 ? void 0 : (_this$restaurantDetai7 = _this$restaurantDetai6.contactDetail) === null || _this$restaurantDetai7 === void 0 ? void 0 : _this$restaurantDetai7.phoneDetail, "");
    }
  }, {
    key: "minPartySize",
    get: function get() {
      var _this$restaurantDetai8, _this$restaurantDetai9;

      return ((_this$restaurantDetai8 = this.restaurantDetail) === null || _this$restaurantDetai8 === void 0 ? void 0 : (_this$restaurantDetai9 = _this$restaurantDetai8.partySizeInfo) === null || _this$restaurantDetai9 === void 0 ? void 0 : _this$restaurantDetai9.restMinPartySize) || 1;
    }
  }, {
    key: "restaurantId",
    get: function get() {
      return this._restaurantId;
    },
    set: function set(_restaurantId) {
      var _this20 = this;

      runInAction(function () {
        _this20._restaurantId = _restaurantId;
      });
    }
  }, {
    key: "showWWYWBanner",
    get: function get() {
      var _this$restaurantDetai10, _this$restaurantDetai11, _this$_restaurantDeta, _this$_restaurantDeta2, _this$estimatedWaitTi;

      var enableWebAheadPromo = (_this$restaurantDetai10 = this.restaurantDetail) === null || _this$restaurantDetai10 === void 0 ? void 0 : (_this$restaurantDetai11 = _this$restaurantDetai10.promoInfo) === null || _this$restaurantDetai11 === void 0 ? void 0 : _this$restaurantDetai11.enableWebaheadPromo;
      var webAheadPromoThreshold = (_this$_restaurantDeta = this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : (_this$_restaurantDeta2 = _this$_restaurantDeta.promoInfo) === null || _this$_restaurantDeta2 === void 0 ? void 0 : _this$_restaurantDeta2.webAheadPromoThreshold;

      if (enableWebAheadPromo && +((_this$estimatedWaitTi = this.estimatedWaitTime) === null || _this$estimatedWaitTi === void 0 ? void 0 : _this$estimatedWaitTi.highQuote) >= webAheadPromoThreshold) {
        return true;
      }

      return false;
    }
  }, {
    key: "webAheadPromoMessage",
    get: function get() {
      var _this$restaurantDetai12, _this$restaurantDetai13;

      return (_this$restaurantDetai12 = this.restaurantDetail) === null || _this$restaurantDetai12 === void 0 ? void 0 : (_this$restaurantDetai13 = _this$restaurantDetai12.promoInfo) === null || _this$restaurantDetai13 === void 0 ? void 0 : _this$restaurantDetai13.webAheadPromoMessage;
    }
  }, {
    key: "restaurantDetail",
    get: function get() {
      return this._restaurantDetail;
    },
    set: function set(restaurantDetail) {
      var _this21 = this;

      runInAction(function () {
        _this21._restaurantDetail = restaurantDetail;
      });
    }
  }, {
    key: "estimatedTime",
    get: function get() {
      return this._estimatedTime;
    },
    set: function set(estimatedTime) {
      var _this22 = this;

      runInAction(function () {
        _this22._estimatedTime = estimatedTime;
      });
    }
  }, {
    key: "waitListTimeDetails",
    get: function get() {
      return this._waitListTimeDetails;
    },
    set: function set(waitListTimeDetails) {
      var _this23 = this;

      runInAction(function () {
        _this23._waitListTimeDetails = waitListTimeDetails;
      });
    }
  }, {
    key: "estimatedWaitTime",
    get: function get() {
      var _this$_waitListTimeDe,
          _this$_waitListTimeDe2,
          _this$_waitListTimeDe3,
          _this24 = this;

      var defaultTime = {
        lowQuote: 0,
        highQuote: 0,
        partySize: this.partySize || 0,
        waitTimeStatus: WAITLIST_STATUS_TYPES.UNAVAILABLE
      };

      if (!this.partySize || ((_this$_waitListTimeDe = this._waitListTimeDetails) === null || _this$_waitListTimeDe === void 0 ? void 0 : _this$_waitListTimeDe.length) === 0) {
        return defaultTime;
      }

      var waitTime = (_this$_waitListTimeDe2 = this._waitListTimeDetails) === null || _this$_waitListTimeDe2 === void 0 ? void 0 : (_this$_waitListTimeDe3 = _this$_waitListTimeDe2.filter(function (value) {
        return value.partySize === _this24.partySize;
      })) === null || _this$_waitListTimeDe3 === void 0 ? void 0 : _this$_waitListTimeDe3[0];

      if (waitTime) {
        return waitTime;
      } else {
        return defaultTime;
      }
    }
  }, {
    key: "isJWFormNotValid",
    get: function get() {
      var _this$errors, _this$errors2, _this$errors3, _this$errors4;

      return ((_this$errors = this.errors) === null || _this$errors === void 0 ? void 0 : _this$errors["email"]) || ((_this$errors2 = this.errors) === null || _this$errors2 === void 0 ? void 0 : _this$errors2["firstName"]) || ((_this$errors3 = this.errors) === null || _this$errors3 === void 0 ? void 0 : _this$errors3["lastName"]) || ((_this$errors4 = this.errors) === null || _this$errors4 === void 0 ? void 0 : _this$errors4["phoneNumber"]);
    }
  }, {
    key: "isWaitlistLongerWait",
    get: function get() {
      var _this$estimatedWaitTi2;

      return ((_this$estimatedWaitTi2 = this.estimatedWaitTime) === null || _this$estimatedWaitTi2 === void 0 ? void 0 : _this$estimatedWaitTi2.waitTimeStatus) === WAITLIST_STATUS_TYPES.LONGER_WAIT;
    }
  }, {
    key: "isWaitlistRestrictWait",
    get: function get() {
      var _this$estimatedWaitTi3;

      return ((_this$estimatedWaitTi3 = this.estimatedWaitTime) === null || _this$estimatedWaitTi3 === void 0 ? void 0 : _this$estimatedWaitTi3.waitTimeStatus) === WAITLIST_STATUS_TYPES.RESTRICT_WAIT;
    }
  }, {
    key: "isWaitlistUnavailable",
    get: function get() {
      var _this$estimatedWaitTi4;

      return ((_this$estimatedWaitTi4 = this.estimatedWaitTime) === null || _this$estimatedWaitTi4 === void 0 ? void 0 : _this$estimatedWaitTi4.waitTimeStatus) === WAITLIST_STATUS_TYPES.UNAVAILABLE;
    }
  }, {
    key: "isWaitlistNoWait",
    get: function get() {
      var _this$estimatedWaitTi5;

      return ((_this$estimatedWaitTi5 = this.estimatedWaitTime) === null || _this$estimatedWaitTi5 === void 0 ? void 0 : _this$estimatedWaitTi5.waitTimeStatus) === WAITLIST_STATUS_TYPES.NO_WAIT;
    }
  }, {
    key: "overrideNoWaitForWL",
    get: function get() {
      var _this$restaurantDetai14;

      return (_this$restaurantDetai14 = this.restaurantDetail) === null || _this$restaurantDetai14 === void 0 ? void 0 : _this$restaurantDetai14.overrideNoWaitTime;
    }
  }, {
    key: "isWaitlistDataDirty",
    get: function get() {
      return this._isWaitlistNumberOfGuestsChange || this._isWaitlistFormDataChange;
    }
  }, {
    key: "joinWaitlistFormContainerRef",
    get: function get() {
      return this._joinWaitlistFormContainerRef;
    }
  }, {
    key: "scrollJoinWaitlistFormElement",
    get: function get() {
      return this._scrollJoinWaitlistFormElement;
    }
  }, {
    key: "joinWaitListFormSubmitCount",
    get: function get() {
      return this._joinWaitListFormSubmitCount;
    }
  }, {
    key: "isHowItWoksModalOpen",
    get: function get() {
      return this._isHowItWoksModalOpen;
    },
    set: function set(_val) {
      var _this25 = this;

      runInAction(function () {
        _this25._isHowItWoksModalOpen = _val;
      });
    }
  }, {
    key: "isCTALoading",
    get: function get() {
      return this._isCTALoading;
    }
  }, {
    key: "isOrderAheadEnabled",
    get: function get() {
      var _this$restaurantDetai15;

      return (_this$restaurantDetai15 = this.restaurantDetail) === null || _this$restaurantDetai15 === void 0 ? void 0 : _this$restaurantDetai15.orderAheadEnabled;
    }
  }, {
    key: "wineWhileYouWaitInfo",
    get: function get() {
      return this._wineWhileYouWaitInfo;
    },
    set: function set(wineWhileYouWaitInfo) {
      var _this26 = this;

      runInAction(function () {
        _this26._wineWhileYouWaitInfo = wineWhileYouWaitInfo;
      });
    }
  }, {
    key: "longerWaitTimeThreshold",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.webAheadConfig) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.estimatedWaitTimeThreshold;
    }
  }, {
    key: "isEditWLConfirmation",
    set: function set(_val) {
      var _this27 = this;

      runInAction(function () {
        _this27._isEditWLConfirmation = _val;
      });
    },
    get: function get() {
      return this._isEditWLConfirmation;
    }
  }]);

  return JoinWaitlistModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_firstName", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_email", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_phoneNumber", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_waitListId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_visitId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_partySize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_eclubOptin", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_waitListPositionValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_requestTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_highQuote", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_lowQuote", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_defaultPartySize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_restaurantId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_currentWaitlistRestNum", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_restaurantWorkHours", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_remoteCheckinEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_isChangeWaitlistModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_isHowItWoksModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_estimatedTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_isWaitListAvailable", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_pdfMenuUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_joinWaitlistFormContainerRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_scrollJoinWaitlistFormElement", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_joinWaitListFormSubmitCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_isCTALoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_wineWhileYouWaitInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_isEditWLConfirmation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_isWaitlistNumberOfGuestsChange", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_isWaitlistFormDataChange", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "pdfMenuUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pdfMenuUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPDFMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPDFMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "partySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubOptin", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubOptin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentWaitlistRestNum", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentWaitlistRestNum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitListId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitListId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visitId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visitId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "address", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "address"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitListPositionValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitListPositionValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lowQuote", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lowQuote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "highQuote", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "highQuote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitListAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitListAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remoteCheckinEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remoteCheckinEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChangeWaitlistModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeWaitlistModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxPartySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxPartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultPartySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultPartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minPartySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minPartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWaitlistDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setWaitlistDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWWYWBanner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showWWYWBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "webAheadPromoMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "webAheadPromoMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantDetail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "estimatedTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "estimatedTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitListTimeDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitListTimeDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "estimatedWaitTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "estimatedWaitTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isJWFormNotValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isJWFormNotValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistLongerWait", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistLongerWait"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistRestrictWait", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistRestrictWait"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistUnavailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistUnavailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistNoWait", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistNoWait"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "overrideNoWaitForWL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "overrideNoWaitForWL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsWaitlisNumberOfGuestsChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsWaitlisNumberOfGuestsChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsWaitlisFormDataChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsWaitlisFormDataChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistDataDirty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistDataDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "joinWaitlistFormContainerRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "joinWaitlistFormContainerRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setJoinWaitlistFormContainerRef", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setJoinWaitlistFormContainerRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollJoinWaitlistFormElement", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "scrollJoinWaitlistFormElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setScrollJoinWaitlistFormElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setScrollJoinWaitlistFormElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "joinWaitListFormSubmitCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "joinWaitListFormSubmitCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setJoinWaitlistFormSubmitCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setJoinWaitlistFormSubmitCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHowItWoksModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHowItWoksModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCTALoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCTALoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsCTALoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsCTALoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderAheadEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderAheadEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wineWhileYouWaitInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "wineWhileYouWaitInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "longerWaitTimeThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "longerWaitTimeThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditWLConfirmation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditWLConfirmation"), _class.prototype)), _class);